import React, { useState } from 'react'

import { Box, Color, Text, withCitrusTheme } from '@gousto-internal/citrus-react'

export type SuitabilityGuidanceProps = {
  /** Who the current selection suits, as a single line. Empty hides it. */
  suitability: string
}

// `minHeight` reserves one line even when there is no text to size against — e.g. loading
// straight into a one-person box, where `displaySuitability` has no prior value.
const Content = withCitrusTheme(Box, () => ({
  transition: 'opacity 200ms ease',
  marginBottom: '24px',
  minHeight: '28px',
}))

/**
 * Always occupies the same space, with only opacity and `aria-hidden` changing, so nothing
 * around it moves as the guidance appears or disappears. `aria-hidden` tracks the prop rather
 * than the transition, so the text leaves the accessibility tree the instant it stops applying.
 */
export const SuitabilityGuidance = ({ suitability }: SuitabilityGuidanceProps) => {
  const showGuidance = suitability.length > 0

  // Holds the last non-empty line while hidden, so it fades out rather than blanking instantly.
  const [displaySuitability, setDisplaySuitability] = useState(suitability)
  if (showGuidance && suitability !== displaySuitability) {
    setDisplaySuitability(suitability)
  }

  return (
    <Content
      data-testid="suitability-guidance"
      aria-hidden={showGuidance ? undefined : true}
      paddingH={0.5}
      paddingV={1}
      style={{ opacity: showGuidance ? 1 : 0 }}
    >
      <Text size={2} color={Color.ColdGrey_800}>
        {displaySuitability}
      </Text>
    </Content>
  )
}
